module.exports = __webpack_public_path__ + "img/camera.877252f4.svg";